import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useHeader } from "../context/HeaderContext";
import Dropdown from "./Dropdown";
import LanguageToggle from "./LanguageToggle";
import "./MyNav.css";

function MyNav() {
  const [menuClick, setMenuClick] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const navRef = useRef(null);
  const { t } = useTranslation("common");
  const { headerKey } = useHeader();

  // Detection for touch devices
  const isTouch = window.matchMedia("(hover: none)").matches;
  
  // Explicitly match the CSS Media Query logic for layout behavior
  const isMobileLayout = window.matchMedia(
    "screen and (max-aspect-ratio: 1/1), screen and (min-aspect-ratio: 1/1) and (height <= 550px)"
  ).matches;

  useEffect(() => {
    const resetAll = () => {
      setMenuClick(false);
      setDropdown(false);
    };
    window.addEventListener("resize", resetAll);
    return () => window.removeEventListener("resize", resetAll);
  }, []);

  useEffect(() => {
    const handleOutside = (e) => {
      if (navRef.current && !navRef.current.contains(e.target)) {
        setDropdown(false);
        setMenuClick(false);
      }
    };
    document.addEventListener("mousedown", handleOutside);
    document.addEventListener("touchstart", handleOutside);
    return () => {
      document.removeEventListener("mousedown", handleOutside);
      document.removeEventListener("touchstart", handleOutside);
    };
  }, []);

  // Helper to close everything and reset "sticky" hover colors
  const handleNavClick = (e) => {
    setDropdown(false);
    setMenuClick(false);
    // e.target.blur() removes focus, resetting the CSS :active/:focus states
    if (e.target) e.target.blur();
  };

  return (
    <nav className="navbar" ref={navRef}>
      <span id="section-title">{headerKey ? t(headerKey) : ""}</span>

      <ul className={menuClick ? "nav-menu active" : "nav-menu"}>
        <li className="nav-item">
          <NavLink
            to="/"
            className="nav-link"
            onClick={handleNavClick}
          >
            {t("nav.home")}
          </NavLink>
        </li>

        <li
          className="nav-item"
          onMouseEnter={() => !isTouch && setDropdown(true)}
          onMouseLeave={() => !isTouch && setDropdown(false)}
        >
          <NavLink
            to="/hobbies"
            className="nav-link"
            onClick={(e) => {
              // MOBILE/PORTRAIT LAYOUT: Direct redirect, no dropdown
              if (isMobileLayout) {
                handleNavClick(e);
                return;
              }

              // LANDSCAPE IPAD/TOUCH: First tap opens dropdown
              if (isTouch && !dropdown) {
                e.preventDefault();
                setDropdown(true);
                return;
              }

              // PC or SECOND TAP: Normal redirect
              handleNavClick(e);
            }}
          >
            {t("nav.hobbies")}
            <i className={`fa-solid fa-angle-down ${dropdown ? "rotate" : ""}`} />
          </NavLink>

          {dropdown && (
            <Dropdown 
              setDropdown={setDropdown} 
              setMenuClick={setMenuClick} 
            />
          )}
        </li>
      </ul>

      <div className="nav-actions">
        <LanguageToggle />
        <div className="menu-icon" onClick={() => setMenuClick(!menuClick)}>
          <i className={`fa-solid ${menuClick ? "fa-xmark" : "fa-bars"}`} />
        </div>
      </div>
    </nav>
  );
}

export default MyNav;